function groupIndexedArray(indexedArray) {
  return indexedArray.reduce(
    (acc, cur, idx, src) => {
      if (idx > 0 && src.length > 2 && cur - src[idx - 1] === 1) {
        acc[acc.length - 1][1] = cur;
      } else {
        acc.push([cur]);
      }
      return acc;
    },
    []
  );
}
export {
  groupIndexedArray
};
